import { Box, Typography } from '@mui/material';
import BookImage1 from 'assets/BookImage1.webp';
import BookImage2 from 'assets/BookImage2.webp';
import { allowedFilesMap } from './DataSetForm';

export default function BookDescription() {
  return (
    <Box>
      <Typography variant='h6'>"Book" Chunking Method Description</Typography>
      <Typography marginTop={1}>Supported file formats are {allowedFilesMap.book.join(', ')}.</Typography>
      <Typography marginTop={3}>
        Since a book is long and not all the parts are useful, if it's a PDF, please setup the page ranges for every
        book in order eliminate negative effects and save computing time for analyzing.
      </Typography>

      <Typography fontWeight='500' marginTop={3}>
        "Book" Examples
      </Typography>
      <Typography marginBottom={3}>The following screenshots are presented to facilitate understanding.</Typography>
      <Box display='flex' overflow='auto' justifyContent='center' gap={1}>
        <img src={BookImage1} alt='Book' width={320} />
        <img src={BookImage2} alt='Book' width={320} />
      </Box>
    </Box>
  );
}
